export default __webpack_public_path__ + "static/media/crop-science.87a7de28.jpg";